// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-modal {
  margin: 40px 0;
  width: var(--modal-width-tablet) !important;
}
.default-modal .ant-modal-content {
  background-color: var(--modal-bg-color);
  color: var(--modal-text-color) !important;
}
.default-modal h1,
.default-modal h2,
.default-modal h3,
.default-modal h4,
.default-modal h5,
.default-modal h6 {
  color: var(--modal-text-color) !important;
}
@media (min-width: 1200px) {
  .default-modal {
    width: var(--modal-width-desktop) !important;
  }
}
.default-modal__logo {
  margin-bottom: 20px;
}
.default-modal__custom-close-icon {
  cursor: pointer;
  line-height: 2rem;
  font-size: 0.9rem;
  width: 2rem;
  height: 2rem;
  text-align: center;
  border-radius: 50%;
  background-color: var(--modal-bg-color);
  color: var(--modals-close-button-color);
}
.default-modal .ant-modal-close {
  display: block;
  border-radius: 50%;
  box-shadow: rgb(170, 170, 170) 0 0 5px 1px;
  width: 2rem;
  right: -12px;
  top: -12px;
  height: auto;
  border: none;
  background-color: transparent;
  outline: none;
}
.default-modal .ant-modal-close:hover {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Modal/Modal.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,2CAAA;AADJ;AAGI;EACI,uCAAA;EACA,yCAAA;AADR;AAII;;;;;;EAMI,yCAAA;AAFR;AAKI;EAlBJ;IAmBQ,4CAAA;EAFN;AACF;AAII;EACI,mBAAA;AAFR;AAKI;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;EACA,uCAAA;AAHR;AAMI;EACI,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;AAJR;AAMQ;EACI,6BAAA;AAJZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
